export default "__VITE_ASSET__QSfUktYd__"